import styled from "styled-components";
import { VoucherGamesListDefaultBox } from "./voucher-games-list.default.box";

export const VoucherGamesListMrGreenCisBox = styled(VoucherGamesListDefaultBox)`
    margin: 0;
    background-color: ${({theme}) => theme.colors.backgroundDark};
`;